import React from 'react';

import authRoute from './authorization';
import appsRoute from './applications';
import setupRoute from './setup';
import managementRoute from './management';
import reportsRoute from './reports';

import {
	ROOT,
	ADMIN,
	CONTRACTOR,
	PROVIDER,
	USER,
} from 'constants/roles.constant';

export const publicRoutes = [...authRoute];

export const protectedRoutes = [
	{
		key: 'dashboard',
		path: '/dashboard',
		component: React.lazy(() => import('views/main/Dashboard')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
		approved: true,
	},
	{
		key: 'pages.accessDenied',
		path: '/unauthorized',
		component: React.lazy(() => import('views/pages/AccessDenied')),
		authority: [],
		approved: false,
		meta: {
			pageContainerType: 'default',
			footer: true,
		},
	},
	...appsRoute,
	...setupRoute,
	...reportsRoute,
	...managementRoute,
];
